import React, { useCallback } from 'react';
import classNames from 'classnames';
import { ResponsiveImage } from '../ResponsiveImage';
import './DesktopProductMediaGalleryThumb.scss';

interface Props {
  src: string;
  alt: string;
  index: number;
  selected: boolean;
  onClick(index: number): void;
}

export const DesktopProductMediaGalleryThumb: React.FC<Props> = ({
  src,
  alt,
  index,
  selected,
  onClick
}) => {
  const handleClick = useCallback(() => onClick(index), [index, onClick]);

  return (
    <button
      className={classNames('DesktopProductMediaGalleryThumb', {
        'DesktopProductMediaGalleryThumb--selected': selected
      })}
      onClick={handleClick}
    >
      <ResponsiveImage src={src} alt={alt} maxWidth={80} maxHeight={110} />
    </button>
  );
};
